import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import { getCakeBrands, getPictureByKey } from '@/views/custom-layout/api';
export default {
  name: 'cake_brands_config',
  components: {
    draggable: draggable,
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    info: Object,
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      colsList: [{
        label: '5列（96*96）',
        value: '5'
      }, {
        label: '5列（84*84）',
        value: '5-1'
      }, {
        label: '4列（110*110）',
        value: '4'
      }],
      bidObj: {},
      list: [],
      rules: {
        type_wrap: [{
          required: true,
          message: '请选择类型',
          trigger: 'change'
        }],
        bg_style: [{
          required: true,
          message: '选项不可为空',
          trigger: 'change'
        }],
        show_title_icon: [{
          required: true,
          message: '选项不可为空',
          trigger: 'change'
        }],
        bg_color: [{
          required: true,
          message: '背景色不可为空',
          trigger: 'change'
        }],
        border_style: [{
          required: true,
          message: '边框设置不可为空',
          trigger: 'change'
        }],
        cols: [{
          required: true,
          message: '列数不可为空',
          trigger: 'change'
        }],
        brand_show_type: [{
          required: true,
          message: '请选择首页品牌显示模式',
          trigger: 'change'
        }],
        category_id: [{
          required: true,
          message: '请选择点击更多时跳转的菜单',
          trigger: 'change'
        }],
        brandList: [{
          required: true,
          message: '品牌不可为空',
          trigger: 'change'
        }],
        rows: [{
          required: true,
          pattern: /^(?:[1-9]|[1-9][0-9])$/,
          message: '请输入1-99之间的正整数！'
        }]
      },
      typeList: [{
        id: 1,
        label: '普通品牌墙',
        imageurl: 'https://res.youlianfuwu.com/mini_program/cake/brand1_indicate.jpg'
      }, {
        id: 2,
        label: '金刚区样式',
        imageurl: 'https://res.youlianfuwu.com/mini_program/cake/brand2_indicate.jpg'
      }],
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      showPictureLibrary: false,
      pictureList: [],
      updateIndex: 0,
      depot: {}
    };
  },
  methods: {
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: 'icon'
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureList = picture[1] || [];
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.value.config.brandList[this.updateIndex]['brand_logo'] = path;
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture(index) {
      // updateIndex: 在onChangePic中对应将组件内第几张图片替换为图库中图片
      // pictureList: 图库中图片列表
      this.updateIndex = index;
      this.showPictureLibrary = true;
    },
    onUpload: function onUpload(index) {
      this.$refs.uploadBanner[index].uploadBanner();
    },
    emitUploadFile: function emitUploadFile(res, item) {
      item.brand_logo = "".concat(this.$ossurl).concat(res);
    },
    changeLine: function changeLine(line) {
      var _this$value$config$bo;
      if (this.value.config.border_style === 1) {
        return;
      }
      var index = this.value.config.border_none.findIndex(function (i) {
        return i === line;
      });
      (_this$value$config$bo = this.value.config.border_none).splice.apply(_this$value$config$bo, [index, Number(index > -1)].concat(_toConsumableArray(index > -1 ? [] : [line])));
    },
    changeBorderStyle: function changeBorderStyle(val) {
      if (val === 1) {
        this.value.config.border_none = [];
      }
    },
    changeType: function changeType(type) {
      this.value.config.type = type;
    },
    // 切换蛋糕数据源 清空原有选择数据
    changeCategory: function changeCategory(category_id) {
      this.value.config.brandList = [];
      // this.value.config.bids = []
      this.bidObj = {};
      category_id && this.loadData();
    },
    // 添加
    addBrand: function addBrand() {
      var _this2 = this;
      if (!this.bidObj.id) {
        this.$message.error('请先选择一个品牌');
        return;
      }
      var data = this.list.find(function (i) {
        return i.id === _this2.bidObj.id;
      });
      this.value.config.brandList.push(data);
      // this.value.config.bids.push(data.id)
      this.bidObj = {};
      this.$refs.form.validateField('brandList');
    },
    // 删除
    deleteBrand: function deleteBrand(index) {
      this.value.config.brandList.splice(index, 1);
      // this.value.config.bids = this.value.config.brandList.map(i => i.id)
    },
    // 获取蛋糕品牌列表
    loadData: function loadData() {
      var _this3 = this;
      getCakeBrands({
        category_id: this.value.config.category_id
      }, this.info.module).then(function (res) {
        _this3.list = res.data;
      });
    }
  },
  created: function created() {
    this.$set(this.value, 'config', _objectSpread({
      // 新添加组件初始数据 start
      type: 1,
      // 选择类型
      name: '品牌严选',
      show_title_icon: 1,
      // 是否显示标题旁边图标
      bg_style: 1,
      //组件边框&颜色
      bg_color: '#ffffff',
      //背景色
      border_style: 1,
      //边框模式
      border_none: [],
      //隐藏边框数组
      cols: '5',
      //列数
      category_id: '',
      //蛋糕数据源
      brand_show_type: 1,
      //首页品牌显示模式
      bids: [],
      // 后端需要用的选择的品牌ID数组
      brandList: [],
      // 用于排序 & 回显 & 中心区域展示的数据
      margin_top: 15,
      //上边距 - 兼容新老组件 默认预置15px
      z_index: 2,
      //层级 - 兼容新老组件 默认预置2
      rows: 2
    }, this.value.config));
    this.getPicture();
    this.value.config.category_id && this.loadData();
  },
  computed: {
    getBorderBoxClass: function getBorderBoxClass() {
      var _this$value$config = this.value.config,
        bg_style = _this$value$config.bg_style,
        border_none = _this$value$config.border_none;
      var className = [];
      if (bg_style !== 2) {
        return className.join(' ');
      }
      var enumClass = {
        1: 'top',
        2: 'right',
        3: 'bottom',
        4: 'left'
      };
      var borderNoneList = border_none.map(function (i) {
        return "border-hide-".concat(enumClass[i]);
      });
      className = className.concat(borderNoneList);
      return className.join(' ');
    },
    menuListFilter: function menuListFilter() {
      return this.menuList.filter(function (i) {
        return ['cake', 'new_cake', 'cake_store'].includes(i.type);
      });
    }
  },
  watch: {
    'value.config.brandList': function valueConfigBrandList(brandList) {
      this.value.config.bids = brandList === null || brandList === void 0 ? void 0 : brandList.map(function (i) {
        return i.id;
      });
    }
  }
};